<script lang="ts">
    import type {ViewableFile} from 'src/typings';
    import {FileViewForm} from 'shared/constants';
    import {getDateFormatter, getLocalization} from 'src/core';
    import {pipe} from 'core/utils';
    import {byteFormatter, loc} from 'shared/utils/pipes';
    import {exists} from 'shared/utils/custom-utils';
    import KpCollapsibleMenuWrapper from 'shared/ui-widgets/menu-wrapper/KpCollapsibleMenuWrapper.svelte';
    import KpButtonStyleAnchor from 'shared/ui-widgets/button/KpButtonStyleAnchor.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let file: ViewableFile;

    const localize = getLocalization();
    const dateFormatter = getDateFormatter();
</script>

<KpCollapsibleMenuWrapper>
    <div slot="main" class="list-item-file">
        <div>
            <h2 class="unset-style file-name">{file.name}</h2>
            <div>
                <code class="full-filename">
                    {#if exists(file.directory)}
                        {pipe(file.directory, loc())} /
                    {/if}
                    {file.filename}
                </code>
            </div>
            <div class="file-metadata">
                <span class="text-muted">
                    {localize(/* @kp-localization commons.DatumVytvoreni */ 'commons.DatumVytvoreni')}:
                    {pipe(file.creationDate, dateFormatter('d.M.yyyy'))}
                </span>
                <span class="text-muted">{localize(/* @kp-localization file.FileSize */ 'file.FileSize')}:
                    {pipe(file.size, byteFormatter())}
                </span>
            </div>
        </div>

        <div class="file-thumbnail">
            {#if (file.viewForms.includes(FileViewForm.THUMBNAIL))}
                <a href="/files/{file.id}">
                    <img src="/files/{file.id}?height=60"
                         height="60"
                         title={localize(/* @kp-localization commons.Nahled */ 'commons.Nahled')}
                         alt={localize(/* @kp-localization commons.Nahled */ 'commons.Nahled')}/>
                </a>
            {/if}
        </div>
    </div>

    <div slot="menu" let:collapsed>
        <li class="collapsible-menu-item">
            <KpButtonStyleAnchor noWrap isBlock={true} buttonSize="xs" href="/files/{file.id}" download={file.filename}>
                <UIcon icon="download"/>
                <span class:sr-only={collapsed}>{localize(/* @kp-localization commons.Stahnout */ 'commons.Stahnout')}</span>
            </KpButtonStyleAnchor>
        </li>
        {#if exists(file.directory)}
            <li class="collapsible-menu-item">
                <KpButtonStyleAnchor noWrap isBlock={true} buttonSize="xs" href="/media-viewer?rootDirectory={file.directory.id}&edit=true#!?file={file.id}">
                    <UIcon icon="zoom-in"/>
                    <span class:sr-only={collapsed}>{localize(/* @kp-localization file.OpenFile */ 'file.OpenFile')}</span>
                </KpButtonStyleAnchor>
            </li>
        {/if}
    </div>
</KpCollapsibleMenuWrapper>

<style lang="less">
    .list-item-file {
        display: grid;
        grid-template-columns: 4fr 1fr;
        gap: 1em;
    }

    .file-name {
        font-weight: bold;
        word-break: break-all;
    }

    .full-filename {
        padding: 2px;
        word-break: break-all;
    }

    .file-metadata {
        display: flex;
        flex-direction: column;
    }

    .file-thumbnail {
        justify-self: center;
    }
</style>